import { Box, Card, CardContent, Skeleton } from "@mui/material";

export const SubscriptionSkeleton = ({ isSmallMobile }: { isSmallMobile: boolean }) => {
  const skeletonCount = 3;

  if (isSmallMobile) {
    return (
      <Box sx={{ mb: 3, mt: 2 }}>
        {Array.from(new Array(skeletonCount)).map((_, index) => (
          <Box
            key={index}
            sx={{
              mb: 3,
              position: 'relative',
            }}
          >
            <Card
              elevation={0}
              sx={{
                backgroundColor: '#FFFFFF',
                borderRadius: '12px',
                padding: 0,
                boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.05)',
              }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <CardContent
                  sx={{
                    textAlign: 'center',
                    pb: 1,
                    px: 2,
                  }}
                >
                  <Skeleton width='60%' height={24} sx={{ mx: 'auto', mb: 1 }} />
                </CardContent>

                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    px: 2,
                    pb: 2,
                    pt: 0,
                  }}
                >
                  <Box
                    sx={{
                      width: '30%',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                      justifyContent: 'center',
                    }}
                  >
                    <Skeleton width='80%' height={40} sx={{ mb: 1 }} />
                    <Skeleton width='100%' height={16} sx={{ mb: 0.5 }} />
                    <Skeleton width='60%' height={14} />
                  </Box>

                  <Box
                    sx={{
                      width: '40%',
                      pl: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                    }}
                  >
                    {Array.from(new Array(3)).map((_, i) => (
                      <Box key={i} sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
                        <Skeleton variant='circular' width={16} height={16} sx={{ mr: 1 }} />
                        <Skeleton width='100%' height={14} />
                      </Box>
                    ))}
                  </Box>

                  <Box
                    sx={{
                      width: '30%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                      pl: 1,
                    }}
                  >
                    <Skeleton width={90} height={36} sx={{ borderRadius: '8px' }} />
                  </Box>
                </Box>
              </Box>
            </Card>
          </Box>
        ))}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          sm: 'repeat(2, 1fr)',
          md: 'repeat(3, 1fr)',
        },
        gap: { sm: 2, md: 3 },
        mb: { sm: 6, md: 10 },
        position: 'relative',
        alignItems: 'stretch',
        maxWidth: '900px',
        mx: 'auto',
      }}
    >
      {Array.from(new Array(skeletonCount)).map((_, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            position: 'relative',
          }}
        >
          <Card
            elevation={0}
            sx={{
              height: '100%',
              backgroundColor: '#FFFFFF',
              borderRadius: '12px',
              padding: 0,
              width: '100%',
            }}
          >
            <CardContent
              sx={{
                textAlign: 'center',
                pb: 1,
                paddingTop: '1.5rem',
              }}
            >
              <Skeleton width='70%' height={28} sx={{ mx: 'auto', mb: 2 }} />
              <Skeleton width='50%' height={60} sx={{ mx: 'auto', mb: 1 }} />
              <Skeleton width='70%' height={24} sx={{ mx: 'auto', my: 2 }} />
              <Skeleton width='60%' height={20} sx={{ mx: 'auto', mb: 1 }} />
            </CardContent>

            <Box sx={{ px: 3, mb: 3, flexGrow: 1 }}>
              {Array.from(new Array(3)).map((_, i) => (
                <Box key={i} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                  <Skeleton variant='circular' width={18} height={18} sx={{ mr: 1.5 }} />
                  <Skeleton width='90%' height={20} />
                </Box>
              ))}
            </Box>

            <Box sx={{ px: 3, pb: 3, pt: 1, mt: 'auto' }}>
              <Skeleton width='100%' height={40} sx={{ borderRadius: '8px' }} />
            </Box>
          </Card>
        </Box>
      ))}
    </Box>
  );
};
